import SharedDummyRowDropdown, { SharedDummyRowDropdownProps } from "../SharedDummyRowDropdown";

type Props = Pick<SharedDummyRowDropdownProps, "items">;

const DummyRowDropdown = ({ items }: Props) => <SharedDummyRowDropdown items={items} usePortal />;

export default DummyRowDropdown;
